// Extracted from Dashboard.js during Phase 4 refactor (sprint 2026-06-20).
// Pure presentational early-return view for users who need to complete the
// terrain profile before seeing their main dashboard.
import React from 'react';
import { Layout } from '../components/Layout';
import TerrainProfile from '../components/TerrainProfile';

export default function TerrainOnboardingView({ language, onClose }) {
  return (
    <Layout>
      <div className="p-4 md:p-8 max-w-7xl mx-auto" data-testid="client-dashboard">
        <div className="mb-4 p-4 rounded-xl border-2 border-primary/30 bg-primary/5">
          <div className="flex items-center justify-between mb-3">
            <h3 className="font-heading text-sm uppercase tracking-wider text-primary">
              {language === 'fr' ? 'Complete ton profil tactique' : 'Complete your tactical profile'}
            </h3>
            <button
              onClick={onClose}
              className="text-xs text-muted-foreground hover:text-foreground"
              data-testid="skip-terrain-btn"
            >
              {language === 'fr' ? 'Plus tard' : 'Later'}
            </button>
          </div>
          <TerrainProfile onComplete={onClose} />
        </div>
      </div>
    </Layout>
  );
}
